import { Button } from "@ebsco-ui/ebsco-ui";
import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import VisitEbscoHelpLink from "../../ebsco-help-link";
import StepContent from "../../step-content";
import messages from "./warning-messages";
import MergeWarningImage from "./warning.svg";

import "./warning.scss";

const block = "validation-warning";

const Warning = ({
  onContinueWithMerge,
  warningMessageDescriptors,
  username
}) => {
  const { formatMessage } = useIntl();
  const handleContinueMergeClick = () => {
    onContinueWithMerge();
  };
  return (
    <StepContent
      stepTitle={formatMessage(messages.mergeAccountAlert)}
      imageUrl={MergeWarningImage}
    >
      <div className={block}>
        <p className={`${block}__information`}>
          <FormattedMessage {...messages.foundFollowingIssues} />
        </p>

        <ul className={`${block}__list`}>
          {warningMessageDescriptors.map(warningMessageDescriptor => (
            <li
              className={`${block}__list-item`}
              key={warningMessageDescriptor.id}
            >
              <FormattedMessage
                {...warningMessageDescriptor}
                values={{
                  username,
                  styledUsername: displayStyledUserName(block)
                }}
              />
            </li>
          ))}
        </ul>
        <Button
          type="button"
          styleType="solid"
          className={`${block}__continue-merge`}
          onClick={handleContinueMergeClick}
        >
          <FormattedMessage {...messages.continueWithMerge} />
        </Button>
        <VisitEbscoHelpLink />
      </div>
    </StepContent>
  );
};

const displayStyledUserName = baseClassName => msg => (
  <span className={`${baseClassName}__list-item__username`}>{msg}</span>
);

Warning.propTypes = {
  onContinueWithMerge: PropTypes.func.isRequired,
  warningMessageDescriptors: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default Warning;
